import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrainings } from '../pages/TrainingsList/redux';
import { selectTrainingsListLoading } from '../pages/TrainingsList/redux/selectors';
import { APIContentRequest } from '../api/types';
import { Brand } from './useSelectBrand';

type GetBrandsContent = (brand: Brand) => { payload: APIContentRequest; type: string };

export const useLoadInitialContent = (): { loaded: boolean; getBrandsContent: GetBrandsContent } => {
  const dispatch = useDispatch();
  const loading = useSelector(selectTrainingsListLoading);
  // TODO:- refactor this when we introduce a real CMS
  const [filterTags, setFilterTags] = useState<string[] | null>(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tags = queryParams.get('tags');

    if (tags) {
      setFilterTags(tags.split(','));
    } else {
      setFilterTags(null);
    }
  }, []);

  const getBrandsContent = useCallback(
    (brand: Brand) => dispatch(fetchTrainings.request({ tags: filterTags, brand })),
    [dispatch, filterTags],
  );

  return { loaded: !loading, getBrandsContent };
};
